const countries = [
  { value: null, text: 'Select', code: null },
  { value: 1, text: 'Afghanistan', code: 'af' },
  { value: 2, text: 'Albania', code: 'al' },
  { value: 3, text: 'Algeria', code: 'dz' },
  { value: 4, text: 'Andorra', code: 'ad' },
  { value: 5, text: 'Angola', code: 'ao' },
  { value: 6, text: 'Antigua & Deps', code: 'ag' },
  { value: 7, text: 'Argentina', code: 'ar' },
  { value: 8, text: 'Armenia', code: 'am' },
  { value: 9, text: 'Australia', code: 'au' },
  { value: 10, text: 'Austria', code: 'at' },
  { value: 11, text: 'Azerbaijan', code: 'az' },
  { value: 12, text: 'Bahamas', code: 'bh' },
  { value: 13, text: 'Bahrain', code: 'bh' },
  { value: 14, text: 'Bangladesh', code: 'bd' },
  { value: 15, text: 'Barbados', code: 'bb' },
  { value: 16, text: 'Belarus', code: 'by' },
  { value: 17, text: 'Belgium', code: 'be' },
  { value: 18, text: 'Belize', code: 'bz' },
  { value: 19, text: 'Benin', code: 'bj' },
  { value: 20, text: 'Bhutan', code: 'bt' },
  { value: 21, text: 'Bolivia', code: 'bo' },
  { value: 22, text: 'Bosnia Herzegovina', code: 'ba' },
  { value: 23, text: 'Botswana', code: 'bw' },
  { value: 24, text: 'Brazil', code: 'br' },
  { value: 25, text: 'Brunei', code: 'bn' },
  { value: 26, text: 'Bulgaria', code: 'bg' },
  { value: 27, text: 'Burkina', code: 'bf' },
  { value: 28, text: 'Burundi', code: 'bi' },
  { value: 29, text: 'Cambodia', code: 'kh' },
  { value: 30, text: 'Cameroon', code: 'cm' },
  { value: 31, text: 'Canada', code: 'ca' },
  { value: 32, text: 'Cape Verde', code: 'cv' },
  { value: 33, text: 'Central African Rep', code: 'cf' },
  { value: 34, text: 'Chad', code: 'td' },
  { value: 35, text: 'Chile', code: 'cl' },
  { value: 36, text: 'China', code: 'cn' },
  { value: 37, text: 'Colombia', code: 'co' },
  { value: 38, text: 'Comoros', code: 'km' },
  { value: 39, text: 'Congo', code: 'cg' },
  { value: 40, text: 'Congo (Democratic Rep)', code: 'cd' },
  { value: 41, text: 'Costa Rica', code: 'cr' },
  { value: 42, text: 'Croatia', code: 'hr' },
  { value: 43, text: 'Cuba', code: 'cu' },
  { value: 44, text: 'Cyprus', code: 'cy' },
  { value: 45, text: 'Czech Republic', code: 'cz' },
  { value: 46, text: 'Denmark', code: 'dk' },
  { value: 47, text: 'Djibouti', code: 'dj' },
  { value: 48, text: 'Dominica', code: 'dm' },
  { value: 49, text: 'Dominican Republic', code: 'do' },
  { value: 50, text: 'East Timor', code: 'tp' },
  { value: 51, text: 'Ecuador', code: 'ec' },
  { value: 52, text: 'Egypt', code: 'eg' },
  { value: 53, text: 'El Salvador', code: 'sv' },
  { value: 54, text: 'Equatorial Guinea', code: 'gq' },
  { value: 55, text: 'Eritrea', code: 'er' },
  { value: 56, text: 'Estonia', code: 'ee' },
  { value: 57, text: 'Ethiopia', code: 'et' },
  { value: 58, text: 'Fiji', code: 'fj' },
  { value: 59, text: 'Finland', code: 'fi' },
  { value: 60, text: 'France', code: 'fr' },
  { value: 61, text: 'Gabon', code: 'ga' },
  { value: 62, text: 'Gambia', code: 'gm' },
  { value: 63, text: 'Georgia', code: 'ge' },
  { value: 64, text: 'Germany', code: 'de' },
  { value: 65, text: 'Ghana', code: 'gh' },
  { value: 66, text: 'Greece', code: 'gr' },
  { value: 67, text: 'Grenada', code: 'gd' },
  { value: 68, text: 'Guatemala', code: 'gt' },
  { value: 69, text: 'Guinea', code: 'gn' },
  { value: 70, text: 'Guinea-Bissau', code: 'gw' },
  { value: 71, text: 'Guyana', code: 'gy' },
  { value: 72, text: 'Haiti', code: 'ht' },
  { value: 73, text: 'Honduras', code: 'hn' },
  { value: 74, text: 'Hungary', code: 'hu' },
  { value: 75, text: 'Iceland', code: 'is' },
  { value: 76, text: 'India', code: 'in' },
  { value: 77, text: 'Indonesia', code: 'id' },
  { value: 78, text: 'Iran', code: 'ir' },
  { value: 79, text: 'Iraq', code: 'iq' },
  { value: 80, text: 'Ireland (Republic)', code: 'ie' },
  { value: 81, text: 'Israel', code: 'il' },
  { value: 82, text: 'Italy', code: 'it' },
  { value: 83, text: 'Ivory Coast', code: 'ci' },
  { value: 84, text: 'Jamaica', code: 'jm' },
  { value: 85, text: 'Japan', code: 'jp' },
  { value: 86, text: 'Jordan', code: 'jo' },
  { value: 87, text: 'Kazakhstan', code: 'kz' },
  { value: 88, text: 'Kenya', code: 'ke' },
  { value: 89, text: 'Kiribati', code: 'ki' },
  { value: 90, text: 'Korea North', code: 'kp' },
  { value: 91, text: 'Korea South', code: 'kr' },
  { value: 92, text: 'Kosovo', code: 'xk' },
  { value: 93, text: 'Kuwait', code: 'kw' },
  { value: 94, text: 'Kyrgyzstan', code: 'kg' },
  { value: 95, text: 'Laos', code: 'la' },
  { value: 96, text: 'Latvia', code: 'lv' },
  { value: 97, text: 'Lebanon', code: 'lb' },
  { value: 98, text: 'Lesotho', code: 'ls' },
  { value: 99, text: 'Liberia', code: 'lr' },
  { value: 100, text: 'Libya', code: 'ly' },
  { value: 101, text: 'Liechtenstein', code: 'li' },
  { value: 102, text: 'Lithuania', code: 'lt' },
  { value: 103, text: 'Luxembourg', code: 'lu' },
  { value: 104, text: 'Macedonia', code: 'mk' },
  { value: 105, text: 'Madagascar', code: 'mg' },
  { value: 106, text: 'Malawi', code: 'mw' },
  { value: 107, text: 'Malaysia', code: 'my' },
  { value: 108, text: 'Maldives', code: 'mv' },
  { value: 109, text: 'Mali', code: 'ml' },
  { value: 110, text: 'Malta', code: 'mt' },
  { value: 111, text: 'Marshall Islands', code: 'mh' },
  { value: 112, text: 'Mauritania', code: 'mr' },
  { value: 113, text: 'Mauritius', code: 'mu' },
  { value: 114, text: 'Mexico', code: 'mx' },
  { value: 115, text: 'Micronesia', code: 'fm' },
  { value: 116, text: 'Moldova', code: 'md' },
  { value: 117, text: 'Monaco', code: 'mc' },
  { value: 118, text: 'Mongolia', code: 'mn' },
  { value: 119, text: 'Montenegro', code: 'me' },
  { value: 120, text: 'Morocco', code: 'ma' },
  { value: 121, text: 'Mozambique', code: 'mz' },
  { value: 122, text: 'Myanmar (Burma)', code: 'mm' },
  { value: 123, text: 'Namibia', code: 'na' },
  { value: 124, text: 'Nauru', code: 'nr' },
  { value: 125, text: 'Nepal', code: 'np' },
  { value: 126, text: 'Netherlands', code: 'nl' },
  { value: 127, text: 'New Zealand', code: 'nz' },
  { value: 128, text: 'Nicaragua', code: 'ni' },
  { value: 129, text: 'Niger', code: 'ne' },
  { value: 130, text: 'Nigeria', code: 'ng' },
  { value: 131, text: 'Norway', code: 'no' },
  { value: 132, text: 'Oman', code: 'om' },
  { value: 133, text: 'Pakistan', code: 'pk' },
  { value: 134, text: 'Palau', code: 'pw' },
  { value: 135, text: 'Panama', code: 'pa' },
  { value: 136, text: 'Papua New Guinea', code: 'pg' },
  { value: 137, text: 'Paraguay', code: 'py' },
  { value: 138, text: 'Peru', code: 'pe' },
  { value: 139, text: 'Philippines', code: 'ph' },
  { value: 140, text: 'Poland', code: 'pl' },
  { value: 141, text: 'Portugal', code: 'pt' },
  { value: 142, text: 'Qatar', code: 'qa' },
  { value: 143, text: 'Romania', code: 'ro' },
  { value: 144, text: 'Russian Federation', code: 'ru' },
  { value: 145, text: 'Rwanda', code: 'rw' },
  { value: 146, text: 'St Kitts & Nevis', code: 'kn' },
  { value: 147, text: 'St Lucia', code: 'lc' },
  { value: 148, text: 'Saint Vincent & the Grenadines', code: 'vc' },
  { value: 149, text: 'Samoa', code: 'ws' },
  { value: 150, text: 'San Marino', code: 'sm' },
  { value: 151, text: 'Sao Tome & Principe', code: 'st' },
  { value: 152, text: 'Saudi Arabia', code: 'sa' },
  { value: 153, text: 'Senegal', code: 'sn' },
  { value: 154, text: 'Serbia', code: 'rs' },
  { value: 155, text: 'Seychelles', code: 'sc' },
  { value: 156, text: 'Sierra Leone', code: 'sl' },
  { value: 157, text: 'Singapore', code: 'sg' },
  { value: 158, text: 'Slovakia', code: 'sk' },
  { value: 159, text: 'Slovenia', code: 'si' },
  { value: 160, text: 'Solomon Islands', code: 'sb' },
  { value: 161, text: 'Somalia', code: 'so' },
  { value: 162, text: 'South Africa', code: 'za' },
  { value: 163, text: 'South Sudan', code: 'ss' },
  { value: 164, text: 'Spain', code: 'es' },
  { value: 165, text: 'Sri Lanka', code: 'lk' },
  { value: 166, text: 'Sudan', code: 'sd' },
  { value: 167, text: 'Suriname', code: 'sr' },
  { value: 168, text: 'Swaziland', code: 'sz' },
  { value: 169, text: 'Sweden', code: 'se' },
  { value: 170, text: 'Switzerland', code: 'ch' },
  { value: 171, text: 'Syria', code: 'sy' },
  { value: 172, text: 'Taiwan', code: 'tw' },
  { value: 173, text: 'Tajikistan', code: 'tj' },
  { value: 174, text: 'Tanzania', code: 'tz' },
  { value: 175, text: 'Thailand', code: 'th' },
  { value: 176, text: 'Togo', code: 'tg' },
  { value: 177, text: 'Tonga', code: 'to' },
  { value: 178, text: 'Trinidad & Tobago', code: 'tt' },
  { value: 179, text: 'Tunisia', code: 'tn' },
  { value: 180, text: 'Turkey', code: 'tr' },
  { value: 181, text: 'Turkmenistan', code: 'tm' },
  { value: 182, text: 'Tuvalu', code: 'tv' },
  { value: 183, text: 'Uganda', code: 'ug' },
  { value: 184, text: 'Ukraine', code: 'ua' },
  { value: 185, text: 'United Arab Emirates', code: 'ae' },
  { value: 186, text: 'United Kingdom', code: 'gb' },
  { value: 187, text: 'United States', code: 'us' },
  { value: 188, text: 'Uruguay', code: 'uy' },
  { value: 189, text: 'Uzbekistan', code: 'uz' },
  { value: 190, text: 'Vanuatu', code: 'vu' },
  { value: 191, text: 'Vatican City', code: 'va' },
  { value: 192, text: 'Venezuela', code: 've' },
  { value: 193, text: 'Vietnam', code: 'vn' },
  { value: 194, text: 'Yemen', code: 'ye' },
  { value: 195, text: 'Zambia', code: 'zm' },
  { value: 196, text: 'Zimbabwe', code: 'zw' },
]

export default countries
